<template>
    <div class="h-full" v-if="hasAccess">
        <top-nav-bar goto="/?page=requests">
            <button @click="navigateTo('')" v-if="annual_leave && !annual_leave.requests.length"
                    class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fal fa-plus mr-2"></i>
                Add Request
            </button>
            <div class="absolute pin-t pin-r flex h-full">
                <button @click="navigateTo(annual_leave.requests[0].id + '/edit')"
                        v-if="annual_leave && annual_leave.requests.length && annual_leave.requests[0].can_change"
                        class="h-full items-center flex bg-secondary mr-6 text-white font-bold font-heading uppercase">
                    <i class="fas fa-pencil mr-2"></i>
                    Edit
                </button>
                <button @click="deleteRequest"
                        v-if="annual_leave && annual_leave.requests.length && annual_leave.requests[0].can_change"
                        class="h-full items-center flex bg-red text-white font-bold font-heading uppercase px-2">
                    <i class="fas fa-times mr-2"></i>
                    Delete
                </button>
            </div>
        </top-nav-bar>

        <empty :visible="annual_leave === null">
            Currently there are no annual leaves available.
        </empty>

        <empty :visible="annual_leave && !annual_leave.requests.length">
            You have not submitted a request for this period.<br><br>
            <template v-if="annual_leave && annual_leave.hasOwnProperty('end_date')">
                Please add your request before the end date of request period, {{annual_leave.end_date}} CET
            </template>
        </empty>

        <div v-if="annual_leave && request">
            <h3 class="text-center py-4">Your current request for "{{annual_leave.name}}"</h3>
            <p class="text-center mb-6">You are free to update or delete this request until the end date of request
                period, {{annual_leave.end_date}} CET.</p>
            <list>
                <list-item>
                    <template slot="icon">
                        <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Submitted at</template>
                    <template slot="sub-title">{{request.created}}</template>
                </list-item>
            </list>

            <div class="mb-6" v-for="(bid, index) in request.bid">
                <list>
                    <list-item>
                        <template slot="icon">
                            <icon icon="fas fa-tag" classes="text-blue w-6 h-6"></icon>
                        </template>
                        <template slot="title">Option</template>
                        <template slot="sub-title">{{bid.option}}</template>
                    </list-item>
                    <list-item v-if="(index + 1) !== request.bid.length">
                        <template slot="icon">
                            <icon icon="fas fa-exclamation-circle" classes="text-blue w-6 h-6"></icon>
                        </template>
                        <template slot="title">Condition</template>
                        <template slot="sub-title">{{bid.condition.toUpperCase()}}</template>
                    </list-item>
                </list>
            </div>
        </div>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                annual_leave: null
            }
        },

        computed: {
            request() {
                return this.annual_leave.requests[0]
            }
        },

        mounted() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.$api('hr').get(`annual-leave`)
                    .then(({data}) => {
                        this.annual_leave = data.data;
                    })
            },
            navigateTo(request_id) {
                this.$router.push('/annual-leave/' + this.annual_leave.id + '/' + request_id);
            },

            deleteRequest() {
                this.$api('hr').delete(`annual-leave/${this.annual_leave.id}/${this.annual_leave.requests[0].id}`)
                    .then(() => {
                        this.fetch()
                    })
            }
        }
    }
</script>
